import { FC, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import cls from 'classnames';
import { useWxWork } from '@cloud/wxwork-workbench';
import PageLayout from '@/layouts/page';
import Table, { ColumnType } from '@/components/Table';
// import Pagination, { defaultPagination } from '@/components/Pagination';
import Toast from '@/components/Toast';
import { SOPType } from '../../constants';
import { queryEntityList } from './service';
import { ActionMessage, ActionStatus, EntityType, SendEntity } from './constants';
import styles from './index.less';
import Tag from '@/components/Tag';

export interface CustomerListProps {
  onBack?: () => void;
}

const CustomerListPage: FC<CustomerListProps> = ({ onBack }) => {
  const { id } = useParams<{ id?: string }>();
  const { type } = useParams<{ type?: string }>();
  const signature = useWxWork();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState<boolean>(true)
  // const [pagination, setPagination] = useState<Pagination>(defaultPagination);
  // const [paginationResult, setPaginationResult] = useState<Pagination>();

  const fetch = useCallback(async () => {
    const res = await queryEntityList(Number(id), signature);
    setData(res);
    setLoading(false);
  }, [id, signature]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const handleOpenChat = (id: string, type: EntityType) => {
    if (type === EntityType.CUSTOMER) {
      wx.openEnterpriseChat({
        externalUserIds: id,
        groupName: '',
        chatId: '',
        fail: function (res) {
          if (res.errMsg.indexOf('function not exist') > -1) {
            Toast.error('版本过低请升级');
          }
        }
      });
    } else if (type === EntityType.GROUP) {
      wx.openEnterpriseChat({
        externalUserIds: '',
        groupName: '',
        chatId: id,
        fail: function (res) {
          if (res.errMsg.indexOf('function not exist') > -1) {
            Toast.error('版本过低请升级');
          }
        }
      });
    }
  }

  const columns: ColumnType<SendEntity>[] = [
    {
      title: `${type === SOPType.CUSTOMER_SOP ? '客户' : '客户群'}`,
      key: 'entity',
      width: 200,
      render: (_, { entityId, avatar, entityName, entityType }) => (
        <div className={styles.entity} onClick={() => handleOpenChat(entityId, entityType)}>
          {avatar ?
            <div className={styles.avatar} style={{ backgroundImage: `url(${avatar})` }} />
          :
            <div className={cls(styles.avatar, styles.notSetted, { [styles.group]: entityType === EntityType.GROUP })} />
          }
          <div className={styles.name}>{entityName}</div>
        </div>
      )
    },
    {
      title: '发送结果',
      key: 'result',
      // width: 120,
      render: (_, { actionStatus, actionMessage }) => {
        if (actionMessage === ActionMessage.HAS_DELIVERY) {
          return <Tag type='success'>发送成功</Tag>
        } else if (actionMessage === ActionMessage.HAS_NO_DELIVERY) {
          if (actionStatus === ActionStatus.UN_SEND) {
            return <Tag>未发送</Tag>
          } else if (actionStatus === ActionStatus.SEND_FAILURE) {
            return <Tag type='error'>发送失败</Tag>
          }
        } else {
          return (
            <div>
              <Tag type='error'>发送失败</Tag>
              <div className={styles.resultTip}>
                {{
                  [ActionMessage.NOT_FRIEND]: '执行人与客户非好友关系',
                  [ActionMessage.LIMIT]: '客户接受消息已达上限'
                }[actionMessage]}
              </div>
            </div>
          )
        }
        return '未知状态';
      }
    },
    // {
    //   title: '发送人',
    //   dataIndex: 'userId',
    //   width: 150,
    //   render: value => {
    //     return (
    //       <span className={styles.userName}
    //       dangerouslySetInnerHTML={{
    //         __html: `<ww-open-data corpid=${signature.corpId} type='userName' openid=${value}></ww-open-data>`
    //       }}
    //     />
    //     )
    //   }
    // },
    {
      title: '实际发送时间',
      dataIndex: 'sendTime',
      render: v => <span>{v ? v : '--'}</span>
    }
  ];

  return (
    <PageLayout onBack={onBack} loading={loading}>
      <header className={styles.info}>
        <span className={styles.summary}>发送给 {data.length || 0} 个{type === SOPType.CUSTOMER_SOP ? '客户' : '群'}</span>
        <span className={styles.tip}>提示：点击昵称可打开会话</span>
      </header>
      <div className={styles.tableWrapper}>
        <Table
          columns={columns}
          rowKey='entityId'
          scroll={{ x: 'max-content' }}
          data={data}
        />
        {/* <Pagination value={paginationResult} onChange={setPagination} /> */}
      </div>
    </PageLayout>
  );
}

export default CustomerListPage;